import React, { useState } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import govtImg from "../../assets/govt_public.png";

import { FaRobot, FaBriefcase } from "react-icons/fa";

const styles = `
  .govt-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .govt-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .govt-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .govt-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .govt-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .govt-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .govt-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .govt-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .govt-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .govt-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .govt-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
    padding: 0 8px;
  }

  .govt-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
    white-space: nowrap;
  }

  .govt-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .govt-img-wrapper {
    flex: 1;
  }

  .govt-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .govt-accordion {
    flex: 1.2;
  }

  .govt-accordion-item {
    margin-bottom: 18px;
  }

  .govt-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .govt-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .govt-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .govt-header {
      height: auto;
      min-height: 90px;
    }

    .govt-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .govt-title-group h2 {
      font-size: 22px;
    }

    .govt-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .govt-header {
      flex-direction: column;
      height: auto;
    }

    .govt-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .govt-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .govt-triangle-left,
    .govt-triangle-right {
      width: 50px;
    }

    .govt-title-group h2 {
      font-size: 19px;
      white-space: normal;
    }

    .govt-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .govt-img-wrapper {
      width: 100%;
    }

    .govt-img-wrapper img {
      max-width: 100%;
    }

    .govt-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .govt-header {
      flex-direction: column;
      height: auto;
    }

    .govt-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .govt-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .govt-header-badge span:first-of-type {
      font-size: 12px;
    }

    .govt-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .govt-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .govt-triangle-left,
    .govt-triangle-right {
      width: 36px;
    }

    .govt-title-group h2 {
      font-size: 15px;
      white-space: normal;
    }

    .govt-title-group svg {
      font-size: 22px !important;
      flex-shrink: 0;
    }

    .govt-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .govt-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .govt-accordion-arrow {
      font-size: 18px;
    }

    .govt-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .govt-title-group h2 {
      font-size: 13px;
    }

    .govt-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function GovernmentPublicServicesPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Surveys & Census",
      content:
        "Conducting public survey and census programs across wider geographies, and villages and metropolitan areas with robotics automation."
    },
    {
      title: "2.Online Feedback Data Gathering",
      content:
        "Crosscheck different news sources including local newspapers, blogs, and social media for comments related to the organization and its work."
    },
    {
      title: "3.Tracking COVID-19 Cases",
      content:
        "Update the database of COVID-19 cases across community facility departments, such as military branches, prison, etc."
    },
    {
      title: "4.Reporting and Compliance for Government Programs",
      content:
        "Automate the organizational tasks involved in reporting and compliance for new and present government agendas along with built-in case management abilities."
    },
    {
      title: "5.ePass Generation",
      content:
        "Automate the process of pass creation."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="govt-header">
        {/* LEFT */}
        <div
          className="govt-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="govt-header-overlay" />

          <div className="govt-header-badge">
            <div className="govt-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic Process Automation - Use Cases</span>

            <span className="govt-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="govt-header-right">
          <div className="govt-triangle-left" />
          <div className="govt-triangle-right" />

          <div className="govt-title-group">
            <FaBriefcase style={{ fontSize: "32px", color: "#2fb7a4" }} />
            <h2>Govt. & Public Services</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="govt-main">
        {/* IMAGE */}
        <div className="govt-img-wrapper">
          <img src={govtImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="govt-accordion">
          {data.map((item, i) => (
            <div key={i} className="govt-accordion-item">
              <div
                className="govt-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="govt-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="govt-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GovernmentPublicServicesPage;
